var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3195 6.31946C11.6582 5.98075 12.2073 5.98075 12.546 6.31946L16.8679 10.6413L16.8928 10.6662C17.3296 11.103 17.6942 11.4675 17.9677 11.7897C18.2529 12.1257 18.4897 12.4723 18.625 12.8886C18.8325 13.5273 18.8325 14.2153 18.625 14.854C18.4897 15.2703 18.2529 15.6168 17.9677 15.9529C17.6942 16.275 17.3296 16.6396 16.8928 17.0764L16.8679 17.1013L12.546 21.4231C12.2073 21.7618 11.6582 21.7618 11.3195 21.4231C10.9808 21.0844 10.9808 20.5353 11.3195 20.1966L15.6413 15.8747C16.1094 15.4066 16.4231 15.092 16.6453 14.8302C16.8609 14.5763 16.9389 14.4298 16.9752 14.318C17.0695 14.0277 17.0695 13.7149 16.9752 13.4246C16.9389 13.3128 16.8609 13.1663 16.6453 12.9123C16.4231 12.6506 16.1094 12.336 15.6413 11.8679L11.3195 7.54603C10.9808 7.20733 10.9808 6.65817 11.3195 6.31946Z",
    fill: "#172136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.93e6a5c6414a0bcfc6a605e554b4c44b.svg";
export { ForwardRef as ReactComponent };